import Resource from './Resource'

class SpainContributionType extends Resource {
  static urlRoot() {
    return '/contracts/spain/contribution_types'
  }
}

export default SpainContributionType
